import React, {useContext} from 'react';
import {EbAuthenticatedAppContext, useAuthentication} from '@eidsivabredband/app-framework';


// mui
import {MyAccountMenu} from "@eidsivabredband/react-component-ui-package";

/**
 * ### Renders a `<MyAccountMenu />` component ###
 * This component displays the account name as a menu button. When clicked, a menu list opens with various actions and links.
 */

function EventLogAccountMenu() {
    const { context } = useContext(EbAuthenticatedAppContext)
    const client = useAuthentication()
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

    const handleSignIn = () => {
        if (!context) return
        client.login(context.authConfig?.scopes || [])
    }

    const handleSignOut = () => {
        if (!context) return
        client.logout()
    }

    return (
        <MyAccountMenu
            isAuthenticated={client.isUserAuthenticated()}
            name={context.userInfo?.givenName + ' ' + context.userInfo?.surname}
            email={context.userInfo?.emailAddress}
            handleSignIn={handleSignIn}
            handleSignOut={handleSignOut}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
        />
    )
};

export default EventLogAccountMenu;